import SV from "../../styles/variables";

const getRandomInt = (max: number) => {
  return Math.floor(Math.random() * Math.floor(max));
};

export const times = [
  "9 am",
  "10 am",
  "11 am",
  "12 pm",
  "1 pm",
  "2 pm",
  "3 pm",
  "4 pm",
  "5 pm",
  "6 pm",
  "7 pm",
  "8 pm",
  "9 pm"
];

export const daysOfWeek = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];

export const formatedNumbers = [
  "< 100",
  "> 100",
  "> 250",
  "> 500",
  "> 1000",
  "> 1500",
  "> 2000",
  "> 5000",
  "> 10000"
];

export const heatmapColors = [
  "#f0f5ff",
  "#cedfff",
  "#adc9ff",
  "#6d9cf9",
  "#3a76eb",
  "#1b57cc",
  "#0a3da2",
  "#02266d",
  "#001133"
];

export const getColor = (numberViews: number): string => {
  if (numberViews < 100) return heatmapColors[0];
  if (numberViews < 250) return heatmapColors[1];
  if (numberViews <= 500) return heatmapColors[2];
  if (numberViews <= 1000) return heatmapColors[3];
  if (numberViews <= 1500) return heatmapColors[4];
  if (numberViews <= 2000) return heatmapColors[5];
  if (numberViews <= 5000) return heatmapColors[6];
  if (numberViews <= 10000) return heatmapColors[7];
  else return heatmapColors[8];
};

export const getFormatedNumber = (numberViews: number): string => {
  if (numberViews < 100) return formatedNumbers[0];
  if (numberViews < 250) return formatedNumbers[1];
  if (numberViews <= 500) return formatedNumbers[2];
  if (numberViews <= 1000) return formatedNumbers[3];
  if (numberViews <= 1500) return formatedNumbers[4];
  if (numberViews <= 2000) return formatedNumbers[5];
  if (numberViews <= 5000) return formatedNumbers[6];
  if (numberViews <= 10000) return formatedNumbers[7];
  else return formatedNumbers[8];
};

export const getData = (): any[] => {
  const data = [];

  for (let x = 0; x < 13; x++) {
    for (let y = 0; y < 7; y++) {
      const randomCol = getRandomInt(10000);
      const color = getColor(randomCol);
      data.push({
        x: times[x], //x-axis of the graph
        y: daysOfWeek[y], //y-axis of the graph
        color
      });
    }
  }
  return data;
};

export const getData2 = (startDate: string, endDate: string): number[][] => {
  const data: number[][] = [];

  for (var x = 0; x < 7; x++) {
    data[x] = [] as number[];
    for (var y = 0; y < 13; y++) {
      data[x][y] = getRandomInt(10000);
    }
  }
  return data;
};

export const dataSet1 = [
  [651, 863, 332, 959, 1173, 3817, 1010, 559, 690, 900, 486, 985, 435],
  [150, 907, 6137, 5093, 1785, 4321, 2442, 4039, 2242, 5458, 268, 171, 289],
  [1106, 2039, 556, 2499, 1335, 7026, 6967, 1951, 9844, 9685, 5013, 355, 186],
  [794, 5148, 1486, 3569, 7089, 1966, 4450, 1956, 8264, 2473, 2821, 584, 201],
  [387, 350, 172, 534, 2719, 15661, 5183, 1777, 1481, 1864, 2624, 771, 845],
  [957, 601, 488, 1839, 3008, 4555, 8156, 6932, 902, 9028, 5460, 5731, 467],
  [879, 436, 377, 5191, 9346, 6487, 6725, 9715, 1065, 3440, 1178, 2794, 608]
];

export default getData;
